/**
 * 格式化数字，添加千分位逗号分隔符
 * @param num 要格式化的数字
 * @returns 格式化后的字符串，如：7000 -> "7,000"
 * @example
 * formatNumberWithCommas(1000) // "1,000"
 * formatNumberWithCommas(1000000) // "1,000,000"
 * formatNumberWithCommas(100) // "100"
 */
export function formatNumberWithCommas(num: number | string): string {
  // Validate string inputs are numeric
  if (typeof num === "string" && (num === "" || isNaN(Number(num)))) {
    return "";
  }

  // Handle special numeric values
  if (!isFinite(Number(num))) {
    return "";
  }

  const numStr = String(num);

  // 处理小数
  const parts = numStr.split(".");
  const integerPart = parts[0];
  const decimalPart = parts[1];

  // 为整数部分添加千分位逗号
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // 如果有小数部分，拼接返回
  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
}
